<template>
    <div class="fullname safe-distance-top">
        <div class="fullname_top">
            <van-icon
                style="position: absolute; left: 10px"
                size="25"
                name="arrow-left"
                @click="to()"
            />
            <div class="my">{{ $route.query.label }}</div>
            <div class="determine" @click="setSave">确定</div>
        </div>
        <div class="fullname_bottm">
            <van-cell-group style="border-radius: 8px">
                <van-field
                    class="fullname_input"
                    v-model="value"
                    :placeholder="'请输入' + $route.query.label"
                    :maxlength="Number(rule.length)"
                    autosize
                    :type="$route.query.type ? $route.query.type : 'text'"
                    :disabled="$route.query.disabled === 'true'"
                >
                    <template v-if="rule.length" #button>
                        <van-button size="small" style="border: none">
                            {{ value.length }}/{{ rule.length }}
                        </van-button>
                    </template>
                </van-field>
            </van-cell-group>
        </div>
        <p v-if="$route.query.key === 'outline'" class="fullname_tips">
            将显示在您发布的内容页面，让大家更好的认识你
        </p>
        <div v-if="$route.query.key === 'name' || $route.query.key === 'orgName'" class="prompt">
            请填写{{ $route.query.label }}，认证通过后无法修改
        </div>
        <van-button
            v-if="$route.query.hasDeleteBtn"
            class="deletBtn"
            type="default"
            round
            @click="toDelet"
            >删除</van-button
        >
    </div>
</template>

<script>
import { Toast } from "vant";
import rules from "@/utils/userInfoFormRules/index.js";
export default {
    name: "InputEdit",
    data() {
        return {
            value: "",
            rule: {},
        };
    },
    created() {
        /* this.$route.query ->
            objName: 编辑对象名,
            key: 编辑对象key,
            label: 编辑信息名称,
            ruleKey: 编辑信息校验key,
            hasDeleteBtn: 是否显示删除按钮,
            disabled: 是否禁用,
            type: 输入框格式
    */
        // 已认证完成
        let pageQuery = this.$route.query;
        this.rule = rules[pageQuery.ruleKey];
        if (sessionStorage.getItem(pageQuery.objName)) {
            let middleValue = JSON.parse(sessionStorage.getItem(pageQuery.objName));
            let keyArr = pageQuery.key.split(".");
            keyArr.forEach((item) => {
                middleValue = middleValue[item];
            });
            this.value =
                this.$global.matchReg(middleValue) &&
                this.$global.matchReg(middleValue) !== "undefined"
                    ? this.$global.matchReg(middleValue)
                    : "";
        }
    },
    methods: {
        to() {
            window.history.go(-1);
        },
        setSave() {
            let pageQuery = this.$route.query;
            let keyArr = pageQuery.key.split(".");
            let obj = sessionStorage.getItem(pageQuery.objName)
                ? JSON.parse(sessionStorage.getItem(pageQuery.objName))
                : {};
            if (this.value == "") {
                if (this.rule.required) {
                    Toast("请填写内容");
                    return;
                }
            } else {
                if (this.rule.pattern) {
                    let pattern = new RegExp(this.rule.pattern);
                    if (!pattern.test(this.value)) {
                        Toast(this.rule.message);
                        return;
                    }
                }
            }
            this.setValue(obj, keyArr, this.value);
            sessionStorage.setItem(pageQuery.objName, JSON.stringify(obj));
            window.history.go(-1);
        },
        setValue(object, path, value) {
            let current = object;
            for (let i = 0; i < path.length - 1; i++) {
                current = current[path[i]];
            }
            current[path[path.length - 1]] = value;
        },
        toDelet() {
            let pageQuery = this.$route.query;
            let obj = sessionStorage.getItem(pageQuery.objName)
                ? JSON.parse(sessionStorage.getItem(pageQuery.objName))
                : {};
            let keyArr = pageQuery.key.split(".");
            obj[keyArr[0]].splice(keyArr[1], 1);
            sessionStorage.setItem(pageQuery.objName, JSON.stringify(obj));
            window.history.go(-1);
        },
    },
};
</script>

<style lang="scss" scoped>
.fullname {
    width: 100vw;
    min-height: 100vh;
    overflow: hidden;
    background: #f5f5f5;

    .fullname_top {
        height: 44px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #fff;
        line-height: 44px;
        align-content: center;
        position: relative;

        .my {
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            background: #fff;
            text-align: center;
        }

        .determine {
            font-size: 15px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            position: absolute;
            right: 15px;
        }
    }

    .fullname_bottm {
        width: 94%;
        margin: 12px auto;
        background: #fff;
        border-radius: 8px;

        .fullname_input {
            border-radius: 8px;

            &::v-deep .van-field__body {
                align-items: flex-end;
                input {
                    height: 33px;
                }
            }
        }
    }

    .prompt {
        width: 94%;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        margin: 0 auto;
    }

    .deletBtn {
        display: block;
        width: 94%;
        margin: 12px auto;
        color: red;
        border: 1px solid #fff;

        &:active::before {
            opacity: 0;
        }
    }
    .fullname_tips {
        margin-left: 12px;
        font-size: 13px;
        color: #999999;
    }
}
</style>
